import { Button } from "~/components/ui/button"
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "~/components/ui/card"
import {Link} from '@remix-run/react'

export function UnauthUser() {
    return (
        <Card className="shadow-none">
            <form>
                <CardHeader className="p-4 pb-0">
                    <CardTitle className="text-sm">Login to play</CardTitle>
                    <CardDescription>
                        Sign up or sign in to play.
                    </CardDescription>
                </CardHeader>
                <CardContent className="grid gap-2.5 p-4">
                    {/*<SidebarInput type="email" placeholder="Email" />*/}
                    <Link to={'/login'}>
                        <Button
                            className="w-full bg-sidebar-primary text-sidebar-primary-foreground shadow-none"
                            size="sm"
                        >
                            Log in
                        </Button>
                    </Link>
                </CardContent>
            </form>
        </Card>
    )
}
